import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import routes from '..'
import { getPageHeight } from './utils'
import HeaderProvider from 'hooks/headerContext'
import { Stack } from '@mui/system'
import Header from 'components/Header'
import AlertDialogProvider from 'hooks/AlertDialogContext'
import AlertDialog from 'components/atoms/alertdialog/AlertDialog'
import NotificationProvider from 'hooks/notificationContext'
import PrivateRoute from 'pages/auth/PrivateRoute'
import { useEffect, useLayoutEffect, useState } from 'react'
import { beginScreen } from 'utils/performance'
import CheckInRequiredSheet from 'components/BottomSheets/CheckInRequiredSheet'
import CHECK_IN_REQUIRED_EVENT, {
  CheckInRequiredDetail,
  START_ATTENDANCE_CHECK_IN_NAVIGATION_STATE,
  startAttendanceCheckInJourney,
} from 'utils/checkInRequiredPrompt'
import { Pages as RoutePages } from '../types'

function Pages() {
  const navigate = useNavigate()
  const location = useLocation()
  useLayoutEffect(() => {
    const route = Object.entries(routes).find(([, value]) => value.path === location.pathname)
    if (route && ['Login', 'Home', 'LeadsListing', 'CreateLead', 'BusinessDetails'].includes(route[0])) return beginScreen(route[0])
  }, [location.pathname, location.key])
  const [showCheckInSheet, setShowCheckInSheet] = useState(false)
  const [checkInMessage, setCheckInMessage] = useState(
    'You need to check in to create lead or opportunity.',
  )

  useEffect(() => {
    const handleCheckInRequired = (event: Event) => {
      const customEvent = event as CustomEvent<CheckInRequiredDetail>
      setCheckInMessage(
        customEvent.detail?.message || 'You need to check in to create lead or opportunity.',
      )
      setShowCheckInSheet(true)
    }

    window.addEventListener(CHECK_IN_REQUIRED_EVENT, handleCheckInRequired as EventListener)
    return () => {
      window.removeEventListener(CHECK_IN_REQUIRED_EVENT, handleCheckInRequired as EventListener)
    }
  }, [])

  const handleCheckInClick = () => {
    setShowCheckInSheet(false)
    if (location.pathname !== routes[RoutePages.Home].path) {
      navigate(routes[RoutePages.Home].path, {
        state: { [START_ATTENDANCE_CHECK_IN_NAVIGATION_STATE]: true },
      })
      return
    }
    startAttendanceCheckInJourney()
  }

  return (
    // TODO: get `getPageTopSpacing` and add as margin top.
    <Box sx={{ height: (theme) => getPageHeight(theme) }}>
      <NotificationProvider>
        <HeaderProvider>
          <AlertDialogProvider>
            <Stack>
              <Header />
              <AlertDialog />
              <CheckInRequiredSheet
                openSheet={showCheckInSheet}
                message={checkInMessage}
                onDismiss={() => setShowCheckInSheet(false)}
                onCheckIn={handleCheckInClick}
              />
              <Routes>
                {Object.values(routes).map(({ path, component: Component }) => {
                  if (path === '/login') {
                    return <Route key={path} path={path} element={<Component />} />
                  } else {
                    return (
                      <Route
                        key={path}
                        path={path}
                        element={
                          <PrivateRoute>
                            <Component />
                          </PrivateRoute>
                        }
                      />
                    )
                  }
                })}
              </Routes>
            </Stack>
          </AlertDialogProvider>
        </HeaderProvider>
      </NotificationProvider>
    </Box>
  )
}

export default Pages
